import { uuidv4 } from '@core/helpers/uuidv4'

/**
 * Base class for all web components.
 */
export class BaseElement extends HTMLElement {
  widgetId = uuidv4()

  /**
   *
   */
  connectedCallback(): void {
    this.createRenderRoot()
  }

  /**
   *
   */
  disconnectedCallback(): void {}

  /**
   *
   */
  createRenderRoot(): void {
    if (!this.shadowRoot) {
      this.attachShadow({ mode: 'open' })
    }
  }

  /**
   *
   */
  render(): void {}
}
